import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ProfileService } from 'src/app/services/profile.service';

@Component({
	selector: 'app-reset-password',
	templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {
	resetPasswordForm: FormGroup;
	showForm: boolean = false;

	confirmPassword: string;
	passwordMatch: boolean;

	messages: Message[] = [];

	email: string;
	token: string;

	constructor(
		private profileService: ProfileService,
		private authService: AuthenticationService,
		private activatedRoute: ActivatedRoute,
		private router: Router
	) {}

	clearMessages() {
		this.messages.length = 0;
	}

	setMessage(msg: Message) {
		this.clearMessages();
		this.messages.push(msg);
	}

	ngOnInit() {
		this.activatedRoute.queryParams.subscribe((params) => {
			this.token = params.token;
			this.email = params.email;
			this.resetPasswordForm = new FormGroup({
				password: new FormControl(null, [ Validators.required ]),
				token: new FormControl(this.token),
				email: new FormControl(this.email)
			});
			this.showForm = true;
		});

		if (this.authService.isAuthenticated()) {
			return this.router.navigate([ '/core' ]);
		}
	}

	onConfirmPassword() {
		const password = this.resetPasswordForm.get('password').value;
		this.passwordMatch = this.confirmPassword === password;
	}

	onResetPassword() {
		this.showForm = false;
		let form = this.resetPasswordForm.value;
		form['token'] = this.token;
		this.profileService.resetPassword(form).subscribe(
			(item) => {
				this.showForm = true;
				this.setMessage({
					severity: 'info',
					detail: item.infoMessage
				});
			},
			(error) => {
				this.showForm = true;
				if ('errorMessage' in error.error) {
					this.setMessage({
						severity: 'error',
						detail: error.error['errorMessage']
					});
				}
			}
		);
	}

	onBackToLogin() {
		this.router.navigate([ '/login' ]);
	}
}
